import * as moment from 'moment';

/* eslint-disable */
export function getChartOptions(symbolType: string) {
  const options: any = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 64
      }
    },
    legend: {
      display: false
    },
    scales: {
      yAxes: [
        {
          ticks: {
            fontFamily: "'Source Sans Pro', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            padding: 18,
            callback: (val: number) => (Number.isInteger(val) ? val : null)
          },
          stacked: true,
          gridLines: {
            drawBorder: false
          }
        }
      ],
      xAxes: [
        {
          ticks: {
            beginAtZero: true,
            fontFamily: "'Source Sans Pro', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            callback: (value: string) => moment.monthsShort()[moment(value).month()].toUpperCase(),
            fontColor: '#666'
          },
          stacked: true,
          maxBarThickness: 100,
          gridLines: {
            display: false,
            tickMarkLength: 25,
            drawBorder: false
          }
        }
      ]
    },
    tooltips: {
      mode: 'index',
      cornerRadius: 6,
      multiKeyBackground: 'transparent',
      caretSize: 0,
      backgroundColor: '#e8e8e8',
      titleFontColor: '#3a3a3a',
      bodyFontColor: '#3a3a3a',
      bodyFontSize: 12,
      displayColors: false,
      xPadding: 18,
      callbacks: {
        title(tooltipItem: any, data: any) {
          const index = tooltipItem[0].index;
          const date = data.labels[index];

          return moment.months()[moment(date).month()] + ' ' + moment(date).year();
        },
        label: (tooltipItem: any) => tooltipItem.yLabel + ' ' + symbolType
      },
      custom(tooltipModel) {
        if (!tooltipModel.dataPoints) {
          this._chart.amadeusTooltipTriangle = false;
          return;
        }
        this._chart.amadeusTooltipTriangle = true;
        const datasetIndex = this._chart.data.datasets.length - 1;
        const datasetMeta = this._chart.getDatasetMeta(datasetIndex);
        const bar = datasetMeta.data[tooltipModel.dataPoints[0].index]._model;
        const tooltipX = bar.x - tooltipModel.width - bar.width / 2 - 7;
        tooltipModel.x = tooltipX > 0 ? tooltipX : 0;
        tooltipModel.y = tooltipModel.dataPoints[0].value < 0 ? bar.y - tooltipModel.height + 8 : bar.y - 8;
      }
    },
    onResize
  };
  const tickFontSize = getDocumentFontSize();
  options.scales.xAxes[0].ticks.fontSize = tickFontSize;
  options.scales.yAxes[0].ticks.fontSize = tickFontSize;

  return options;
}

export function onResize(chart: any, newSize: { width: number; height: number }) {
  if (0 === newSize.width) {
    // chart being created dynamically
    return;
  }
  const fontSize = getDocumentFontSize();
  chart.options.scales.xAxes[0].ticks.minor.fontSize = fontSize;
  chart.options.scales.yAxes[0].ticks.minor.fontSize = fontSize;
  chart.options.scales.yAxes[0].ticks.maxTicksLimit = Math.floor(newSize.height / 50);
}

function getDocumentFontSize() {
  return parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('font-size'), 10);
}

function drawTooltipTriangle(ctx, tooltip) {
  ctx.beginPath();
  ctx.moveTo(tooltip.x + tooltip.width - 1, tooltip.y + tooltip.height / 2 + 7);
  ctx.lineTo(tooltip.x + tooltip.width - 1, tooltip.y + tooltip.height / 2 - 7);
  ctx.lineTo(tooltip.x + tooltip.width + 6, tooltip.y + tooltip.height / 2);
  ctx.fillStyle = '#e8e8e8';
  ctx.fill();
}

export const plugins = [
  {
    afterDraw(chartInstance /* easingValue */) {
      if (chartInstance.amadeusTooltipTriangle) {
        drawTooltipTriangle(chartInstance.ctx, chartInstance.tooltip._view);
      }
    }
  }
];
